import { useTranslation } from "@refinedev/core";
import { IModalProps, Modal } from "components/modal";
import { Tag } from "components/tag";
import { IEventIdsItem, IPromotionCouponItem } from "interfaces";
import { get } from "lodash";
import { getApplyToProductTypeLabel } from "utills/helpers";
interface ICouponInfoModalProps extends IModalProps {
  couponData: IPromotionCouponItem | null;
  events: IEventIdsItem[];
}

export const CouponInfoModal = ({
  onClose,
  open,
  couponData,
  events,
}: ICouponInfoModalProps) => {
  const { translate, getLocale } = useTranslation();
  return (
    <Modal title="Event List" onClose={onClose} open={open}>
      <div className="flex flex-col w-full gap-y-4 divide px-4 py-3.5 text-base sm:max-w-xl">
        <div className="relative flex items-start justify-between gap-x-6">
          <p className="flex-1 font-semibold leading-6">Coupon Code</p>
          <div className="flex-1 text-right leading-6 text-sm">
            <Tag text={couponData?.code ?? ""} type={"blue"} />
          </div>
        </div>
        <div className="relative flex items-start justify-between gap-x-6">
          <p className="flex-1 font-semibold leading-6">Condition Name</p>
          <p className="flex-1 text-right text-sm leading-6">
            {couponData?.note}
          </p>
        </div>
        <div className="relative flex flex-col gap-4">
          <div className="flex-1 font-semibold leading-6 flex flex-wrap items-center gap-x-2">
            Events{" "}
            <Tag
              text={getApplyToProductTypeLabel(
                couponData?.apply_to_product_type
              )}
            />{" "}
          </div>
          <ol className="list-decimal pl-4 space-y-2.5 text-sm">
            {(couponData?.event_ids ?? []).map((eventId) => (
              <li key={eventId}>
                {get(
                  events.find((event) => event.id === eventId),
                  `name_${getLocale()}`,
                  ""
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Modal>
  );
};
